/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import { MWLSwitch } from 'react-web-white-label'

const DpsToggleSwitch = ({
  onChange,
  size = 'medium',
  label,
  group = false,
  groupOptions = [],
  color = 'primary',
  disabled = false,
  className,
  labelPlacement = 'end',
  checked,
}) => {
  return (
    <div className="Stage-Two-Toggle-container">
      <MWLSwitch
        color={color}
        size={size}
        label={label}
        onChange={onChange}
        group={group}
        groupOptions={groupOptions}
        labelPlacement={labelPlacement}
        disabled={disabled}
        checked={checked}
        className={`button btn--${className} dPSButtonComponentSection`}
      />
    </div>
  )
}

export default DpsToggleSwitch
